import React from 'react'
// ##
import PackageUnitsTable from '../../modules/PackageUnit/components/PackageUnitsTable'

export default function PackageUnitPage() {
  return <PackageUnitsTable />
}
